import React, {useContext, useEffect, useRef, useState} from 'react';
import {Form, Input, Table} from 'antd';
import '@/style/EditTable.css';

const EditableContext = React.createContext(null);
const EditableRow = ({ index, ...props }) => {
    const [form] = Form.useForm();
    return (
        <Form form={form} component={false}>
            <EditableContext.Provider value={form}>
                <tr {...props} />
            </EditableContext.Provider>
        </Form>
    );
};

const EditableCell = ({
                          title,
                          editable,
                          children,
                          dataIndex,
                          record,
                          handleSave,
                          required,
                          ...restProps
                      }) => {
    const [editing, setEditing] = useState(false);
    const inputRef = useRef(null);
    const form = useContext(EditableContext);
    useEffect(() => {
        if (editing) {
            inputRef.current.focus();
        }
    }, [editing]);

    const toggleEdit = () => {
        setEditing(!editing);
        form.setFieldsValue({
            [dataIndex]: record[dataIndex],
        });
    };

    const save = async () => {
        try {

            const values = await form.validateFields();
            toggleEdit();
            handleSave({ ...record, ...values });
        } catch (errInfo) {
            console.log('Save failed:', errInfo);
        }
    };
    let childNode = children;
    if (editable) {
        childNode = editing ? (
            <Form.Item
                style={{
                    margin: 0,
                }}
                name={dataIndex}
                rules={[
                    {
                        required: required,
                        message: `${title} 为空.`,
                    },
                ]}
            >
                <Input ref={inputRef} onPressEnter={save} onBlur={save} />
            </Form.Item>
        ) : (
            <div
                className="editable-cell-value-wrap"
                style={{
                    paddingRight: 24,
                }}
                onClick={toggleEdit}
            >
                {children}
            </div>
        );
    }

    return <td {...restProps}>{childNode}</td>;
};

/**
 * 可编辑表格扩展：
 * 1、去掉了新增、删除按钮；
 * 2、增加分页
 * 3、单元格编辑单行数据回传
 * @param doCallData
 * @param rows
 * @param columnss
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const EditableTableExt = ({ doCallData, rows , columnss ,...props })=> {
    const handleSave = (row) => {
        const newData = [...rows];
        const index = newData.findIndex((item) => row.pkid === item.pkid);
        const item = newData[index];
        // 新增回填
        doCallData({ ...item, ...row });
    };

    const components = {
        body: {
            row: EditableRow,
            cell: EditableCell,
        },
    };
    const columns = columnss.map((col) => {
        if (!col.editable) {
            return col;
        }

        return {
            ...col,
            onCell: (record) => ({
                record,
                editable: col.editable,
                dataIndex: col.dataIndex,
                title: col.title,
                required:col.required,
                handleSave: handleSave,
            }),
        };
    });
    return (
        <div>
            <Table
                {...props}
                components={components}
                rowClassName={() => 'editable-row'}
                /*bordered*/
                dataSource={rows}
                columns={columns}
            />
        </div>
    );
}
export default EditableTableExt;